export default __webpack_public_path__ + "static/media/conductos.dff55e77.jpg";